<div class="subheader with-padding flgrow">
    <div class="row align-items-center">
      <div class="col-6 col-lg-3">
        <div class="input-group">
          <input
            class="form-control"
            type="text"
            name="searchTerm"
            placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="searchTerm"
            autocomplete="off"
            (keyup.enter)="onSearchFilter()"
          />
          <div class="input-group-append">
            <button
              type="button"
              class="btn btn-primary"
              (click)="onSearchFilter()"
            >
              <em class="fa fa-search"></em>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-6" *ngIf="dealerList?.length > 0">
        <div class="input-group">
          <ng-multiselect-dropdown
            style="width: 100%"
            [settings]="dropdownSettings"
            [data]="dealerList"
            placeholder="{{ 'lblSearchDealer' | translate }}"
            [(ngModel)]="selectedDealers"
            (ngModelChange)="onChangeDealer()"
          >
          </ng-multiselect-dropdown>
        </div>
      </div>
  
      <!-- Date Range Picker -->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="date">
          <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
          [(ngModel)]="selectedDate" (ngModelChange)="onDateRangeChanged($event)" required/>
        </div>
      </div>
  
  
      <!-- Clear Button -->
      <button
        type="submit"
        (click)="onClearFilter()"
        class="btn btn-primary btn-md"
        ngbTooltip="{{ 'lblClearFilters' | translate }}"
        placement="bottom"
        aria-label="Center Align"
      >
        <em class="far fa-times-circle font16 align-top"></em>
      </button>
        <a
          class="ml-2 btn btn-outline-primary"
          href="javascript:void(0);"
          (click)="onRefresh()"
          aria-label="Center Align"
        >
          <em class="fas fa-sync fa-lg"></em>
        </a>
        <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto" >
          <!-- Excel -->
          <button type="button" (click)="exportAsXLSX()" 
              ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align"  style="margin-right: 10px;">
              <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
          </button>
          <!-- PDF -->
          <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" 
              ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
              <em class="far fa-file fa-2x"></em>
              <span class="bdg">PDF</span>
          </button>
      </div>
    </div>
  </div>

  <div class="container prel">
    <div class="row">
      <div class="c12">
        <div class="card mb-3">
          <!-- Body Header -->
          <div class="card-header d-flex justify-content-between" translate>
            lblCallDealerLog
            <div class="font16 fontbold">
              <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
              {{ totalCount }}
              &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
            </div>
          </div>
  
          <!-- Body Content -->
          <div
            class="table-responsive max-h254"
            infinite-scroll
            [infiniteScrollDistance]="scrollDistance"
            [infiniteScrollThrottle]="throttle"
            [scrollWindow]="false"
            (scrolled)="onScrollDown()"
          >
            <table class="tablest1">
              <thead>
                <tr>
                  <th style="width: 55px" scope="col">#</th>
                  <th scope="col" style="width:300px" translate>lblDealerName</th>
                  <th scope="col" class="text-right" sortable="totalTrackerCalls" (sort)="onSort($event)" translate>
                    lblTotalTrackerCalls
                  </th>
                  <th scope="col" class="text-right" sortable="totalCheckInCalls" (sort)="onSort($event)" translate>
                    lblTotalCheckInCalls
                  </th>
                  <th *ngIf="!hideColumn"  scope="col" class="text-right" sortable="totalWidgetCalls" (sort)="onSort($event)" translate>
                    lblTotalWidgetCalls
                  </th>
                </tr>
              </thead>
  
              <tbody>
                <ng-container
                  *ngIf="
                  dealerWiseCallHistoryList?.length > 0;
                    else load_NotFound_Template
                  "
                >
                  <tr *ngFor="let item of dealerWiseCallHistoryList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td style="width:300px">
                      <ngb-highlight [result]="item.dealerName"> </ngb-highlight>
                    </td>
                    <td class="text-right" (click)="ViewDetails(item,Applications.StatusTracker)">
                      <div style="margin-right: 60px">
                      <ngb-highlight [result]="item.totalTrackerCalls" ngbTooltip="{{'lblView' | translate}}" container="body" tooltipClass="custom-revert">
                      </ngb-highlight>
                    </div>
                    </td>
                    <td class="text-right" (click)="ViewDetails(item,Applications.CheckIn)">
                      <div style="margin-right: 40px">
                      <ngb-highlight [result]="item.totalCheckInCalls" ngbTooltip="{{'lblView' | translate}}" container="body" tooltipClass="custom-revert"> </ngb-highlight>
                    </div>
                    </td>
                    <td *ngIf="!hideColumn" class="text-right" (click)="ViewDetails(item,Applications.Widget)">
                      <div style="margin-right: 60px">
                      <ngb-highlight [result]="item.totalWidgetCalls"  ngbTooltip="{{'lblView' | translate}}" container="body" tooltipClass="custom-revert"> </ngb-highlight>
                    </div>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_NotFound_Template>
                  <tr>
                    <td colspan="8" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>